import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerSections = [
    {
      title: 'Services',
      links: [
        { name: 'Social Media Marketing', href: '/services' },
        { name: 'Web Development', href: '/services' },
        { name: 'App Development', href: '/services' },
        { name: 'Digital Strategy', href: '/services' }
      ]
    },
    {
      title: 'Company',
      links: [
        { name: 'About Us', href: '/about' },
        { name: 'Our Team', href: '/about' },
        { name: 'Careers', href: '/about' },
        { name: 'Contact', href: '/contact' }
      ]
    },
    {
      title: 'Resources',
      links: [
        { name: 'Blog & Insights', href: '#' },
        { name: 'Case Studies', href: '#' },
        { name: 'Digital Lab', href: '#' },
        { name: 'Free Tools', href: '#' }
      ]
    },
    {
      title: 'Support',
      links: [
        { name: 'Help Center', href: '#' },
        { name: 'Privacy Policy', href: '#' },
        { name: 'Terms of Service', href: '#' },
        { name: 'Cookie Policy', href: '#' }
      ]
    }
  ];

  const socialLinks = [
    // { name: 'LinkedIn', icon: 'Linkedin', href: '#', color: 'hover:text-blue-600' },
    // { name: 'Twitter', icon: 'Twitter', href: '#', color: 'hover:text-blue-400' },
    { name: 'Instagram', icon: 'Instagram', href: '#', color: 'hover:text-pink-600' },
    { name: 'Facebook', icon: 'Facebook', href: '#', color: 'hover:text-blue-700' },
    { name: 'YouTube', icon: 'Youtube', href: '#', color: 'hover:text-red-600' }
  ];

  const contactInfo = [
    {
      icon: 'Mail',
      label: 'Email',
      value: 'singhcreations23@gmail.com',
      href: 'mailto:singhcreations23@gmail.com'
    },
    {
      icon: 'Phone',
      label: 'Phone',
      value: '+91-7982843491',
      href: 'tel:+917982843491'
    },
    {
      icon: 'MapPin',
      label: 'Address',
      value: 'Tilak Nagar, Delhi ,110018',
      href: '#'
    }
  ];

  return (
    <footer className="bg-secondary text-secondary-foreground">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <Link to="/home" className="flex items-center space-x-3 mb-6">
              <div className="relative">
                <div className="w-12 h-12 bg-gradient-to-br from-primary to-accent rounded-lg flex items-center justify-center brand-shadow">
                  <svg 
                    viewBox="0 0 24 24" 
                    className="w-7 h-7 text-white"
                    fill="currentColor"
                  >
                    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                  </svg>
                </div>
                <div className="absolute -top-1 -right-1 w-3 h-3 bg-accent rounded-full animate-pulse"></div>
              </div>
              <div>
                <h1 className="text-xl font-bold text-white">Singh Creations</h1>
                <p className="text-sm text-white/80 -mt-1">Digital Atelier</p>
              </div>
            </Link>

            <p className="text-white/80 mb-6 leading-relaxed">
              Where creativity meets technology. We craft transformative digital experiences that elevate brands and create meaningful connections.
            </p>

            {/* Contact Info */}
            <div className="space-y-3">
              {contactInfo?.map((contact, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <Icon name={contact?.icon} size={16} className="text-accent mt-1 flex-shrink-0" />
                  <div>
                    <div className="text-sm text-white/60">{contact?.label}</div>
                    {contact?.href?.startsWith('#') ? (
                      <div className="text-sm text-white/90">{contact?.value}</div>
                    ) : (
                      <a 
                        href={contact?.href}
                        className="text-sm text-white/90 hover:text-accent brand-transition"
                      >
                        {contact?.value}
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Footer Links */}
          <div className="lg:col-span-3">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              {footerSections?.map((section, index) => (
                <div key={index}>
                  <h3 className="font-semibold text-white mb-4">{section?.title}</h3>
                  <ul className="space-y-3">
                    {section?.links?.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        <Link
                          to={link?.href}
                          className="text-white/80 hover:text-accent brand-transition text-sm"
                        >
                          {link?.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Newsletter CTA */}
        <div className="mt-16 pt-12 border-t border-white/10">
          <div className="bg-gradient-to-r from-primary/20 to-accent/20 rounded-2xl p-8 text-center">
            <h3 className="text-2xl font-bold text-white mb-4">
              Ready to Transform Your Digital Presence?
            </h3>
            <p className="text-white/80 mb-6 max-w-2xl mx-auto">
              Let's discuss how we can help your business achieve extraordinary growth through strategic digital solutions.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link to="/contact-us">
                <Button
                  variant="default"
                  className="bg-conversion hover:bg-conversion/90 text-conversion-foreground brand-hover-lift"
                  iconName="Calendar"
                  iconPosition="left"
                  iconSize={18}
                >
                  Schedule Free Consultation
                </Button>
              </Link>
              <Link to="/services">
                <Button
                  variant="outline"
                  className="border-white text-white hover:bg-white hover:text-secondary"
                  iconName="ArrowRight"
                  iconPosition="right"
                  iconSize={18}
                >
                  View Our Services
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            {/* Copyright */}
            <div className="text-white/60 text-sm">
              © {currentYear} Singh Creations. All rights reserved. Crafted with passion for digital excellence.
            </div>

            {/* Social Links */}
            <div className="flex items-center space-x-4">
              <span className="text-white/60 text-sm mr-2">Follow us:</span>
              {socialLinks?.map((social, index) => (
                <a
                  key={index}
                  href={social?.href}
                  className={`text-white/60 ${social?.color} brand-transition p-2 hover:bg-white/10 rounded-lg`}
                  aria-label={`Follow us on ${social?.name}`}
                >
                  <Icon name={social?.icon} size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Additional Links */}
          <div className="mt-4 pt-4 border-t border-white/5 flex flex-wrap items-center justify-center gap-6 text-xs text-white/40">
            <span>Privacy Policy</span>
            <span>•</span>
            <span>Terms of Service</span>
            <span>•</span>
            <span>Cookie Policy</span>
            <span>•</span>
            <span>Accessibility</span>
            <span>•</span>
            <span>Sitemap</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;